// The door-side reader of the authentication verdict the app injects through
// `configureIntegrationsData` (ruling 65,
// `docs/monorepo-ui-floor-rulings/65-identity-crosses-by-injection.md`).
//
// Headless by construction: no design system, no router, no store, no `@/`.
// `useIsAuthenticated` has no package hook and no owning package — its verdict
// is provider-aware and store-coupled — so it crosses per consuming domain as a
// resolved boolean rather than opening an `@heidi/auth` read door.
//
// The seam it reads is PACKAGE-scoped, not door-scoped: its own header says a
// door that lands later extends that ONE object instead of opening a second
// seam, so this door reaches it by relative path exactly as `./connected-apps`
// already does. `requireIntegrationsDataPort` is what makes the member throw
// naming the key rather than degrading to `undefined`.

import { requireIntegrationsDataPort } from '../../document-inbox/data/config';

/** The app's provider-aware authentication verdict. */
export const useIsAuthenticated = (): boolean =>
  requireIntegrationsDataPort('useIsAuthenticated')();
